import { SxProps } from '@mui/material';

export const colorPreview: SxProps = {
  width: '100%',
  height: '100%',
};
